import { checkImageUrl } from './helpers';

export default function preloadImages(
  imgUrls,
  progressHandler,
  errorHandler,
  finishedHandler
) {
  const total = imgUrls.length;
  let current = 0;
  const processImage = event => {
    current++;
    event.type === 'error' ? errorHandler(current) : progressHandler(current);
    if (current === total && finishedHandler) finishedHandler();
  };
  imgUrls.forEach(url => {
    if (checkImageUrl(url)) {
      let img = new window.Image();
      img.src = url;
      img.onload = processImage;
      img.onerror = processImage;
    } else {
      processImage({ type: 'error' });
    }
  });
  return total;
}
